import { ComponentProps } from 'react';
import Spin from 'antd/es/spin';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import clsx from 'clsx';

import './OpSpin.scss';

interface OpSpinProps extends ComponentProps<typeof Spin> {
  centered?: boolean;
}

/**
 * OpSpin is a wrapper around Ant Design's Spin component.
 * It displays a loading spinner to indicate content is being loaded or processed.
 * 
 * Use this component to show loading states for asynchronous operations, data fetching,
 * or any process that requires users to wait. Can be centered within its container.
 * 
 * @example
 * <OpSpin />
 * <OpSpin centered tip="Loading..." />
 * <OpSpin spinning={isLoading}><YourContent /></OpSpin>
 * 
 */
export const OpSpin = ({ className, centered, ...spinProps }: OpSpinProps) => {
  return (
    <Spin
      className={clsx('op-spin', className, { 'op-spin--centered': centered })}
      indicator={<LoadingOutlined />}
      size="large"
      {...spinProps}
    />
  );
};
